import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';
import { db } from '../instant';
import { Event } from 'src/schema';

interface Props {
    event?: Event;
    open: boolean;
    onClose: () => void;
}

export default function DeleteEventDialog(props: Props) {
    const { user } = db.useAuth();

    if (props.event === null) {
        return <></>;
    }

    const deleteAndClose = async () => {
        if (props.event) {
            // NOTE: Not actually deleting images for now

            await db.transact([db.tx.events[props.event.id].delete()]);

            props.onClose();
        }
    };

    const eventName = props.event?.name || '<UNDEFINED>';

    return (
        <Dialog open={props.open} onClose={props.onClose}>
            <DialogTitle>Really delete this event?</DialogTitle>
            <DialogContent>
                <DialogContentText>The event &quot;{eventName}&quot; will be deleted. This action cannot be undone.</DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={props.onClose} autoFocus>
                    Cancel
                </Button>
                <Button disabled={!user} onClick={deleteAndClose} color="error">
                    Delete
                </Button>
            </DialogActions>
        </Dialog>
    );
}
